<template>
  <div class="dsfa-sc-data-overview">
    <DsfSCPanel title="数据总览" :iconUrl="iconUrl">
      <div class="dsfa-sc-data-overview-block">
        <div
          class="dsfa-sc-data-overview-block-wrap"
          v-for="(item, index) in list"
          :key="index"
        >
          <DsfSCBlock
            class="dsfa-sc-data-overview-content"
            align="center"
            :bg-color="item.bgColor"
            :title="item.title"
            :number="item.number"
            :unit="item.unit"
            @click.native="clickItem(item, index)"
          >
            <div class="dsfa-sc-data-overview-block-icon-wrap">
              <img
                class="dsfa-sc-data-overview-block-icon"
                :src="item.imgUrl"
                alt=""
              />
            </div>
          </DsfSCBlock>
        </div>
      </div>
    </DsfSCPanel>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfSCDataOverview",
  ctrlCaption: "数据总览",
  mixins: [$mixins.control],
  inject: ["page"],
  data() {
    return {
      iconUrl:require("_statistics-cloud/assets/styles/img/leaderCockpit/icon-sjzl.png"),
      list: [],
      mapList: {},
      randomNum: 1,
    };
  },
  computed: {},
  created() {
    this.$http.get("/static/data/dsf.scdataoverview.json").then(({ data }) => {
      this.mapList = data || {};
      let list = this.mapList[this.page.acNav] || [];

      _.forEach(list, (it) => {
        it.number = Number(it.number);
      });

      this.list = list;
      this._timeout = setTimeout(() => {
        this.setRandomNum();
      });
    });
  },
  beforeDestroy() {
    clearTimeout(this._timeout);
  },
  methods: {
    setRandomNum() {
      let { list } = this;
      if (!list.length) return;
      let index = this.utils.randomNum(0, list.length - 1);
      let number = this.utils.randomNum(0, 3);
      this.$set(list[index], "number", list[index].number + number);
      let timeout = this.utils.randomNum(2000, 3500);
      this._timeout = setTimeout(() => {
        this.setRandomNum();
      }, timeout);
    },
    clickItem(_, index) {
      if (index == 1) {
        dsf.layer.openDialog.call(this, {
          title: "当前调查项目列表",
          className: "dsfa-sc-survey-project-list-dialog dsfa-sc-dialog",
          content: "DSFSCSurveyProjectList",
        });
      }
    },
  },
});
</script>

<style lang="scss">
@import '_statistics-cloud/assets/styles/pc/dataOverview.scss';
</style>